module.exports = __webpack_public_path__ + "static/media/no_stocks_nri.77b485ac.svg";